export const linkTemplate = (
  node: HTMLAnchorElement,
) => `<one-link href="${node.href}" target="_blank">${node.innerHTML}</one-link>`;

export default linkTemplate;
